<div *transloco="let t">
	<div class="sheet-header">
		<div class="sheet-header-pill"></div>
	</div>

	<div class="op-mb-30">
		<div class="co-app-header">
			<header class="op-header-3">{{ t('CO_APP.INVITE.confirmCoAppDetails') }}</header>
			<div>{{ t('CO_APP.INVITE.checkInfo') }}</div>
		</div>

		<div class="co-app-info">
			<div class="field">
				<div class="op-body-2 label">{{ t('CO_APP.INVITE.fullName') }}</div>
				<div class="value-row">
					<span class="op-body-1"> {{ data.firstName }} {{ data.lastName }}</span>
				</div>
			</div>

			<div class="field">
				<div class="op-body-2 label">{{ t('CO_APP.INVITE.phoneNumber') }}</div>
				<div class="value-row">
					<span class="op-body-1">{{ data.phoneNumber }}</span>
				</div>
			</div>

			<div class="field">
				<div class="op-body-2 label">{{ t('CO_APP.INVITE.emailAddress') }}</div>
				<div class="value-row">
					<span class="op-body-1">{{ data.emailAddress }}</span>
				</div>
			</div>

			<div class="field">
				<div class="op-body-2 label">{{ t('CO_APP.INVITE.preferredLanguage') }}</div>
				<div class="value-row">
					<span class="op-body-1">{{
						data.preferredLanguage === 'EN' ? t('PERSONAL_INFO.english') : t('PERSONAL_INFO.spanish')
					}}</span>
				</div>
			</div>
		</div>

		<div class="footer-section">
			<button
				mat-flat-button
				color="primary"
				class="invite-btn"
				(click)="sendInvite(sheetActions.SEND_INVITE)"
				name="confirmAndSend"
				id="confirmAndSend"
				[opTagClick]="'co-app-invite confirm-and-send'"
			>
				{{ t('CO_APP.INVITE.confirmAndSend') }}
			</button>

			<button
				class="op-full-width floating-button op-mt-20"
				mat-flat-button
				color="secondary"
				name="editDetails"
				id="editDetails"
				[opTagClick]="'co-app-invite edit-details'"
				(click)="closeSheet(sheetActions.CLOSE)"
				type="button"
			>
				{{ t('CO_APP.INVITE.edit') }}
			</button>
		</div>
	</div>
</div>
